
export class ImaginaeToken  {
    public accessToken: string;
    public refreshToken: string;
    public expiresAt: number;

    constructor() {
        this.accessToken="";
        this.refreshToken="";
        this.expiresAt=0;
    }

   public getAccessToken():string {
        return  this.accessToken;
    }

    public setAccessToken(accesstoken:string) {
        this.accessToken = accesstoken;
    }

    public getRefreshToken():string  {
        return  this.refreshToken;
    }

    public setRefreshToken(refreshstoken:string) {
        this.refreshToken = refreshstoken;
    }

    public getExpiresAt():number  {
        return  this.expiresAt;
    }

    public setExpiresAt(expiresat:number) {
        this.expiresAt = expiresat;
    }
}